export default {
  OPEN_CDA_MODAL: 'OPEN_CDA_MODAL',
  CLOSE_CDA_MODAL: 'CLOSE_CDA_MODAL'
}
